import * as React from "react";
const SvgView = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M6.309 2.002A.758.758 0 0 0 6.25 2l.058.002Z"
      fill="currentColor"
    />
    <path
      d="M6.309 2.002 6.249 2a.75.75 0 0 0-.745.671c-.099.745-.518 1.326-1.088 1.767a4.573 4.573 0 0 1-1.813.827.75.75 0 0 0 .294 1.47A6.07 6.07 0 0 0 5.5 5.49v.21c-.106.731-.521 1.302-1.084 1.738a4.573 4.573 0 0 1-1.813.827.75.75 0 0 0 .294 1.47A6.07 6.07 0 0 0 5.5 8.49v2.582a20.399 20.399 0 0 0-2.856.186.75.75 0 0 0 .212 1.484c.834-.119 2.762-.3 4.86-.03 1.74.224 3.52.748 4.905 1.8-1.523.672-2.947 1.628-3.977 2.958-1.592-.169-3.516-.189-5.962.033a.75.75 0 1 0 .136 1.494c5.382-.49 8.019.243 10.23 1.08.326.124.648.252.97.38 1.92.764 3.88 1.543 7.232 1.543a.75.75 0 1 0 0-1.5c-3.052 0-4.762-.678-6.657-1.43-.33-.13-.666-.264-1.015-.396a19.68 19.68 0 0 0-3.17-.936c1.262-1.253 3.046-2.085 4.908-2.575 2.29-.604 4.552-.653 5.8-.425a.75.75 0 0 0 .268-1.476c-1.502-.274-3.99-.198-6.45.45-.235.062-.471.13-.707.203-1.776-1.701-4.189-2.416-6.32-2.69-.307-.04-.61-.07-.907-.094v-2.64a6.077 6.077 0 0 0 2.603 1.245.75.75 0 0 0 .294-1.471 4.58 4.58 0 0 1-1.813-.827C7.52 7.002 7.104 6.43 7 5.699V5.49c.055.047.11.091.167.135a6.077 6.077 0 0 0 2.436 1.11.75.75 0 0 0 .294-1.47 4.58 4.58 0 0 1-1.813-.827c-.575-.445-.996-1.03-1.09-1.781a.75.75 0 0 0-.685-.655Z"
      fill="currentColor"
    />
    <path
      d="M17 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-1.5 3a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgView;
